<div class="col-xl-12 active-p">
  <div class="filter cm-content-box box-primary">
    <div class="content-title">
      <div class="cpa">
        <i class="fa-sharp fa-solid fa-filter me-2"></i
        >{{ "general.filter" | translate }}
      </div>
      <div class="tools">
        <a (click)="filterCollaps = false" class="btn btn-default btn-icon-md"
        ><i class="fa fa-close"></i
        ></a>
      </div>
    </div>

    <div class="cm-content-body form excerpt">
      <div class="card-body">
        <div class="row">
          <div class="col-xl-6">
            <div class="row">
              <div class="col-xl-6 col-sm-12 mb-3">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <label for="date" class="form-label">{{
                        "vehicle-control.date" | translate
                      }}</label>
                  </div>
                  <div class="col">
                    <p-calendar
                      id="date"
                      [(ngModel)]="filter.date"
                      [placeholder]="
                        'vehicle-control.date-placeholder' | translate
                      "
                      [showTime]="false"
                      [showButtonBar]="true"
                      appendTo="body"
                      (onSelect)="onDateChange($event)"
                    ></p-calendar>
                  </div>
                </div>
              </div>
              <div class="col-xl-6 col-sm-12 mb-3">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <label for="vehicle" class="form-label">{{
                        "vehicle-control.vehicle" | translate
                      }}</label>
                  </div>
                  <div class="col">
                    <p-dropdown
                      [options]="vehicleOptions"
                      type="single"
                      response="value"
                      version="ngModel"
                      [(ngModel)]="filter.vehicle"
                      [filter]="true"
                      [placeholder]="
                        'vehicle-control.vehicle-placeholder' | translate
                      "
                      [disabled]="!filter.date"
                      (onChange)="onVehicleChange($event?.value)"
                      [showClear]="true"
                    ></p-dropdown>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-xl-12 col-sm-12 mb-3">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <label for="vehicle" class="form-label">{{
                        "vehicle-control.form" | translate
                      }}</label>
                  </div>
                  <div class="col">
                    <p-dropdown
                      [options]="formOptions"
                      type="single"
                      response="value"
                      version="ngModel"
                      [(ngModel)]="filter.formTab"
                      [filter]="true"
                      [placeholder]="
                        'vehicle-control.form-placeholder' | translate
                      "
                      [disabled]="!filter.vehicle"
                      (onChange)="onSelectFormItem($event?.value)"
                      [showClear]="true"
                    ></p-dropdown>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div class="col-12 d-flex justify-content-end mt-3">
            <button
              class="btn btn-danger light"
              (click)="clearFilter()"
              type="button"
            >
              {{ "general.clear-filter" | translate }}
            </button>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-xl-4">
    <app-cards
      [title]="'vehicle-control.forms' | translate"
      footerDivider="border-0 pb-0 "
      styleBody="px-0"
    >
      <div bodyContent>
        <div class="px-3 mb-4">
          <input
            type="search"
            class="form-control"
            [placeholder]="'common.search' | translate"
            [(ngModel)]="searchForm"
            (input)="handleSearch()"
          />
        </div>
        <ng-container>
          <div style="height: 60vh; overflow-y: auto">
            <div
              *ngIf="filteredList?.length === 0"
              class="text-center text-muted py-3"
            >
              <app-empty-data
                [title]="'vehicle-control.empty-title' | translate"
                [message]="'vehicle-control.empty-msg' | translate"
                icon="mdi mdi-information-outline"
                containerClass="opacity-50"
                iconSize="40px"
                iconColor="gray"
                titleSize="10px"
                titleColor="gray"
                messageSize="14px"
                messageColor="gray"
              ></app-empty-data>
            </div>


            <div *ngFor="let group of groupedList" class="m-3">
              <div
                class="group-button"
                (click)="toggleGroup(group.id)"
                style="cursor: pointer" role="button"  tabindex="-1"
              >
                <h6 class="m-0 fw-bold">{{ group.title }}</h6>
                <span>
      <i
        class="bi"
        [ngClass]="{
          'bi-chevron-down': !collapsedGroups[group.id],
          'bi-chevron-up': collapsedGroups[group.id]
        }"
      ></i>
    </span>
              </div>

              <div
                *ngIf="collapsedGroups[group.id]"
                class="group-items"
              >
                <div
                  class="d-flex align-items-center justify-content-between custom-hover form-menu"
                  *ngFor="let item of group.items"
                  [ngClass]="{
        'left-line-active':
          item?.id === selectedForm?.id &&
          item?.formId === selectedForm?.formId
      }"
                >
                  <button
                    class="p-3 btn text-start flex-grow-1"
                    (click)="onFormSelect(item)"
                  >
                    <div class="item-name fw-bold">{{ item.formTitle }}</div>
                    <p
                      class="mb-1"
                      style="font-weight: 400; font-size: 12px; margin-top: 2px"
                    >
                      {{ item.title }}
                    </p>
                    <div
                      [ngClass]="item?.isActive ? 'badge-success' : 'badge-danger'"
                      class="badge light border-0"
                    >
                      {{
                        item.isActive
                          ? ("common.active" | translate)
                          : ("common.passive" | translate)
                      }}
                    </div>
                  </button>
                </div>
              </div>
            </div>

          </div>
        </ng-container>
      </div>
    </app-cards>
  </div>
  <div class="col-xl-8">
    <app-cards
      [title]="'vehicle-control.question-answers' | translate"
      footerDivider="border-0 pb-0 "
      styleBody="px-0"
    >
      <div bodyContent>
        <div class="px-3 mb-4">
          <input
            type="search"
            class="form-control"
            [placeholder]="'vehicle-control.search' | translate"
            [(ngModel)]="searchQuestion"
            (ngModelChange)="onSearchChange()"
          />
        </div>

        <div
          *ngIf="objectKeys(filteredAnswersList)?.length === 0"
          class="text-center text-muted py-3"
        >
          <app-empty-data
            [title]="'vehicle-control.empty-question-answer-title' | translate"
            [message]="'vehicle-control.empty-question-answer-msg' | translate"
            icon="mdi mdi-information-outline"
            containerClass="opacity-50"
            iconSize="40px"
            iconColor="gray"
            titleSize="10px"
            titleColor="gray"
            messageSize="14px"
            messageColor="gray"
          ></app-empty-data>
        </div>

        <div *ngFor="let tabKey of objectKeys(filteredAnswersList); let i = index">
          <div class="tab-content" [id]="'myTabContent-' + i">
            <div class="tab-pane fade show active" [id]="'bordered-' + i" role="tabpanel">
              <div class="accordion accordion-primary-solid" style="padding-left: 1.5rem; padding-right: 1.5rem">
                <div class="accordion-item">
                  <button
                    class="accordion-header d-flex align-items-center"
                    [id]="'accord-' + i"
                    data-bs-toggle="collapse"
                    [attr.data-bs-target]="'#collapse-' + i"
                    [attr.aria-controls]="'collapse-' + i"
                    aria-expanded="false"
                    type="button"
                  >
                    <span class="accordion-header-text">{{ tabKey }}</span>
                    <span class="accordion-header-indicator"></span>
                </button>
                  <div
                    [id]="'collapse-' + i"
                    class="collapse accordion__body show"
                    [attr.aria-labelledby]="'accord-' + i"
                  >
                    <div class="accordion-body-text">
                      <div class="table-responsive active-projects">
                        <p-table
                          [rowHover]="true"
                          responsiveLayout="stack"
                          paginatorDropdownAppendTo="body"
                          [value]="filteredAnswersList[tabKey]"
                        >
                          <ng-template pTemplate="header">
                            <tr>
                              <th scope="col">
                          <span class="p-column-title" *ngIf="tabKey!= 'Fotoğraflar'">
                            {{ "vehicle-control.question" | translate }}
                          </span>
                              </th>
                              <th scope="col">
                          <span class="p-column-title" *ngIf="tabKey!= 'Fotoğraflar'">
                            {{ "vehicle-control.answer" | translate }}
                          </span>
                              </th>
                              <th scope="col">
                          <span class="p-column-title" *ngIf="tabKey!= 'Fotoğraflar'">
                            {{ "vehicle-control.description" | translate }}
                          </span>
                              </th>
                            </tr>
                          </ng-template>
                          <ng-template pTemplate="body" let-answer>
                            <tr *ngIf="tabKey!= 'Fotoğraflar'">
                              <td>{{ answer?.formTabItem?.title }}</td>
                              <td>{{ answer?.answerValue }}</td>
                              <td>{{ answer?.description }}</td>
                            </tr>

                            <tr *ngIf="tabKey== 'Fotoğraflar'">
                              <td>
                                <i class="pi pi-image"></i>
                                {{ answer?.createdAt | dateFormat :true }}
                                <button
                                  pButton
                                  type="button"
                                  icon="pi pi-download"
                                  class="p-button-rounded p-button-text warning-btn"
                                  (click)="download(answer?.answerValue)"
                                ></button>
                              </td>
                            </tr>
                          </ng-template>
                        </p-table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </app-cards>
  </div>
</div>

<app-loading [fullScreen]="true" [loading]="loading"></app-loading>
